/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */
import 'babel-polyfill';
import React from 'react';
import FastClick from 'fastclick';
import injectTapEventPlugin from 'react-tap-event-plugin';
import Context from './Context';
import { getCookie } from './api';
import { LOGIN_USER_SUCCESS } from './constants/Constants.js';
import jwtDecode from 'jwt-decode';
import * as api from './api';
import IntlRouter from './routes/IntlRouter';
import { Provider } from 'react-redux';
import { createStore, combineReducers } from 'redux';
import * as myreducers from './reducers';
import theroutes from './routes/routes';
import messages from './messages';
import { render } from 'react-dom';
import { browserHistory } from 'react-router';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import theme from './theme.js';
import { loadBackend } from './actioncreators/LoginActions';
import settings from './components/settings';

injectTapEventPlugin();
window.React = React;

function run() {
  let thestore;

  const reducers = combineReducers({
    ...myreducers
  });

  thestore = createStore(reducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

  let routes = theroutes(thestore);

  const dest = document.getElementById('app');
  Context.getInstance().onInsertCss = () => {};
  Context.getInstance().onSetTitle = () => {};
  Context.getInstance().onSetMeta = () => {};
  Context.getInstance().onPageNotFound = () => {};

  let token = getCookie('jwt');
  if (token && token !== 'undefined') {
    loadBackend(token)(thestore.dispatch);
  }

  const locale = messages.getLocale();
  let strings;
  if (messages.locales[locale]) {
    strings = messages.locales[locale];
  } else {
    strings = messages.locales.en;
    messages.locales[locale] = strings;
  }
  strings = messages.getLocalizedStrings();

  let intlData = {
    locales: [locale],
    messages: strings
  };

  let component = (
    <Provider store={thestore}>
      <MuiThemeProvider muiTheme={getMuiTheme(theme)}>
        <IntlRouter history={browserHistory} {...intlData}>
          {routes}
        </IntlRouter>
      </MuiThemeProvider>
    </Provider>
  );
  render(component, dest, () => {
    let css = document.getElementById('css');
    if (css) {
      css.parentNode.removeChild(css);
    }
  });
}

Promise.all([
  new Promise(resolve => {
    if (window.addEventListener) {
      window.addEventListener('DOMContentLoaded', resolve);
    } else {
      window.attachEvent('onload', resolve);
    }
  }).then(() => FastClick.attach(document.body))
]).then(run);



// WEBPACK FOOTER //
// /src/app.js